import { useEffect, useState } from 'react';
import { getWorkspaceMembers, getPendingInvites, WorkspaceMember, PendingInvite } from '@/lib/api/workspaces';

export function useWorkspaceMembers(workspaceId: string | null) {
  const [members, setMembers] = useState<WorkspaceMember[]>([]);
  const [invites, setInvites] = useState<PendingInvite[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refresh = async () => {
    if (!workspaceId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const [membersData, invitesData] = await Promise.all([
        getWorkspaceMembers(workspaceId),
        getPendingInvites(workspaceId),
      ]);
      setMembers(membersData);
      setInvites(invitesData);
    } catch (err) {
      setError(err as Error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, [workspaceId]);

  return { members, invites, loading, error, refresh };
}
